
import Vue from 'vue'
import EditorBtn from '@/pages/product/components/EditorBtn.vue'
import AddToCartBtn from '@/pages/product/components/AddToCartBtn.vue'
import OutOfStock from '@/pages/product/components/OutOfStock.vue'
import { requestSampleMsg } from '@/constants'
export default Vue.extend({
  components: {
    EditorBtn,
    AddToCartBtn,
    OutOfStock
  },
  props: {
    elementPosition: {
      type: String,
      required: false,
      default:''
    }
  },
  computed: {
    isOrderPlainProduct(): boolean {
      return this.$store.state.isOrderPlainProduct
    },
    hasStock(): boolean {
      return this.$store.getters.hasStock
    },
    whatsappSampleMsg(): string {
      const url = window.location.href
      return requestSampleMsg(url)
    }
  },
  methods: {
    handleValidateQuantity() {
      this.$emit('validateQuantity')
    }
  }
})
